import * as actions from "../actionTypes"

const initialState = {
    value: undefined,
}

export default function selectedEnterpriseView(state = initialState, action) {
    switch (action.type) {
        case actions.SET_SELECTED_ENTERPRISE_VIEW: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
